(function ($) {
    'use strict';
  
    class FileUploadQuestion {
      /**
       *
       * @param {*} questionId
       */
      constructor (question, storeAnswerRoute) {
        this.storeAnswerRoute = storeAnswerRoute;
        this.questionSlug = question.slug;
        this.tableId = 'file-upload-table-' + question.id;
        this.tableObj = $('#' + this.tableId);
  
        this.messageId = 'file-upload-message-' + question.id;
        this.messageObj = $('#' + this.messageId);
        this.messageObj.hide();
        this.messageObj.removeClass('hide');
        this.messageTextContainerObj = this.messageObj.find('p');
        this.defaultMessageText = 'Sorry, there was a problem with one or more files.<br />Allowed file types are pdf, jpeg, bmp, png, tiff, zip, doc, docx.<br />File size limit is 12MB. ';
  
        this.tableHeadObj = this.tableObj.find('.js-repeater-table-head');
  
        this.rowCount = this.tableObj.data('row-count');
        this.$rowContainer = this.tableObj.find('.js-repeater-row-container');
        this.$activeRow = null;
  
        // Bind events
        this.tableObj.on('click', '.js-delete-file', $.proxy(this.confirmDeleteFile, this));
        this.tableObj.on('blur', '.js-file-description', $.proxy(this.updateUserAnswer, this));
  
        console.log('Construction complete', this.questionSlug);
      }
  
      /**
       * Show / hide upload error messages
       * @param {*} message
       */
      displayErrorMessage (message) {
        let messageString = this.defaultMessageText;
  
        // We could look at the response from the
        // upload to provide a more detailed
        // error message
        // if (this.isJson(message)) {
        //   console.log(message);
        // }
        this.messageTextContainerObj.html(messageString);
        this.messageObj.show();
      }
      hideErrorMessage () {
        this.messageObj.hide();
      }
  
      /**
       * Add a new row to the tables of files
       * once the upload is complete
       *
       * @todo - add the file ID the new row as as Data Attribute data-id="{{encrypt($file->id)}}"
       * @todo - add the encrypted fileID value as a hidden input
       * @todo - add the correct loop index into the new File Description file
       *
       * @param {*} answer
       */
      addFileToTable (answer) {
        let uploadedFile = answer.userAnswer.uploaded_file;
        let autoFileTitle = uploadedFile.information['document-description'];
        // console.log('Doc desc from server: ' + autoFileTitle);
  
        let newRow = $(`<tr class="js-repeater-row" data-row-index="${this.rowCount}">`);
        newRow.html(`
          <td>
            <input id="${this.questionSlug}.${this.rowCount}.id" name="${this.questionSlug}[value][${this.rowCount}][id]" type="hidden" value="${uploadedFile.encrypted_id}" class="u-visually-hidden" />
            ${uploadedFile.file_name}
          </td>
          <td>
            <label for="file-desc" class="u-visually-hidden">File description</label>
            <input class="js-file-description" type="text" name="${this.questionSlug}[value][${this.rowCount}][document-description]" maxlength="500" value="${autoFileTitle}" />
          </td>
          <td>
            <button type="button" class="btn btn--delete js-delete-file">
              <span class="u-visually-hidden">Delete file</span>
              <span class="icon-cross"></span>
            </button>
          </td>
        `);
        newRow.appendTo(this.$rowContainer);
  
        // Update the count for the next row
        this.rowCount++;
  
        // Check the table header is visible
        // now we have at least one row
        if (this.tableHeadObj.hasClass('u-visually-hidden')) {
          this.tableHeadObj.removeClass('u-visually-hidden');
        }
      }
  
      /**
       * Serialize all the inputs in the file table
       * and post to update end point
       */
      updateUserAnswer () {
        
        let $fileInputs = $("input[name^='" + this.questionSlug + "']");
        let requestData = '_token=' + document.head.querySelector('meta[name="csrf-token"]').content;
        requestData += '&' + $fileInputs.serialize();
        console.log(requestData);
        // Make the request
        let ajaxPromise = $.ajax({
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          },
          type: 'POST',
          url: this.storeAnswerRoute,
          data: requestData,
          dataType: 'JSON'
        });
  
        ajaxPromise.done($.proxy(this.updateUserAnswerSuccess, this));
        ajaxPromise.fail($.proxy(this.updateUserAnswerFailure, this));
      }
  
      /**
       * If a file has been deleted
       * there is some DOM tidying up
       * to do
       *
       * We know this has happened
       * because this.$activeRow is
       * a jQuery object, not null
       *
       * @param {*} data
       */
      updateUserAnswerSuccess (data) {
        if (this.$activeRow !== null) {
          let self = this;
  
          // Remove the 'active' row
          // and reset the variable
          this.$activeRow.remove();
          this.$activeRow = null;
  
          // Re-index the remaining rows
          let remainingRows = this.tableObj.find('.js-repeater-row');
          let $thisRow;
          let rowIndex;
          let $idInput;
          let $descInput;
          remainingRows.each(function (counter) {
            $thisRow = $(this);
            rowIndex = $thisRow.data('row-index');
            $idInput = $thisRow.find('input[name="' + self.questionSlug + '[value][' + rowIndex + '][id]"]');
            $descInput = $thisRow.find('input[name="' + self.questionSlug + '[value][' + rowIndex + '][document-description]"]');
  
            $thisRow.data('row-index', counter);
            $idInput.attr('name', self.questionSlug + '[value][' + counter + '][id]');
            $descInput.attr('name', self.questionSlug + '[value][' + counter + '][document-description]');
          });
  
          // Update the count for the next row
          this.rowCount++;
        }
      }
  
      /**
       * Fail silently for now
       * The worst case is a
       * document title is lost
       * @param {*} data
       */
      updateUserAnswerFailure (data) {
        return true;
      }
  
      /**
       * Use generic modal to render a
       * delete file confirmation box
       *
       * @param event
       */
      confirmDeleteFile (e) {
        e.preventDefault();
        let $deleteButton = $(e.target);
  
        this.$activeRow = $deleteButton.closest('.js-repeater-row');
        this.$activeRow.css('background-color', 'red');
  
        let title = 'Are you sure you want to delete this file?';
        let confirmButtonText = 'Yes, delete it now';
        let deleteCallback = $.proxy(this.doDeleteFile, this);
        let cancelCallback = $.proxy(this.cancelDeleteFile, this);
  
        const confirmationModal = new Framework.Modal({
          'mainEl': document.getElementById('container'),
          'id': 'deleteFileConfirmation',
          'title': title,
          'description': '',
          'hideCloseButton': true,
          'buttons': [
            {
              'text': 'Cancel',
              'className': 'btn--outline',
              'close': true,
              'callback': function () {
                confirmationModal.hide();
                cancelCallback();
              }
            },
            {
              'text': confirmButtonText,
              'callback': function () {
                confirmationModal.hide();
                deleteCallback();
              }
            }
          ]
        });
        confirmationModal.show();
      }
  
      /**
       * Reset the background colour
       * of the active row
       */
      cancelDeleteFile () {
        this.$activeRow.css('background-color', '');
      }
  
      /**
       * Append a hidden input to the from
       * next to the file to be deleted
       * Then call updateUserAnswer()
       */
      doDeleteFile () {
        let rowIndex = this.$activeRow.data('row-index');
        let $firstCell = this.$activeRow.find('td:first');
        $firstCell.append(`<input type="hidden" name="${this.questionSlug}[value][${rowIndex}][remove]" value="true">`);
        this.updateUserAnswer();
      }
  
      /**
       * Helper func to test
       * whether a sting is JSON
       *
       * @param {*} str
       *
       * @returns bool
       */
      isJson (str) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      }
    }
  
    this.FileUploadQuestion = FileUploadQuestion;
  }).call(Framework, jQuery);